import { StarsDropDown } from '@ps/web-shared-components';
import type { StarsDropDownProps } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import CurrencyIcon from '@swf/components/CurrencyIcon/CurrencyIcon';
import { select } from '@swf/core/store';

import { currencyDropdown, currencyIcon, currencyLabel, wrapper } from './CurrencyLimit.scss';

interface OwnProps {
  initialFieldValue?: number;
}

type Props = StarsDropDownProps & OwnProps;

const CurrencyLimit: React.FC<Props> = ({
  id,
  label,
  options,
  initialFieldValue,
  labelContent,
  ...rest
}) => {
  useField(id, { initialValue: initialFieldValue });
  const displayedCurrency = useSelector(select.account.getLimitCurrency);

  return (
    <div className={wrapper}>
      <StarsDropDown
        id={id}
        label={label}
        options={options}
        icon={
          <div className={currencyIcon}>
            <CurrencyIcon currency={displayedCurrency} variant="dropdown" />
            <select disabled>
              <option>{displayedCurrency}</option>
            </select>
          </div>
        }
        className={currencyDropdown}
        labelClassName={currencyLabel}
        labelContent={labelContent}
        {...rest}
      />
    </div>
  );
};

export default CurrencyLimit;
